export const Colors = {
    // Grayscale
    GS0: 'var(--color-gs0)',
    GS100: 'var(--color-gs100)',
    GS200: 'var(--color-gs200)',
    GS300: 'var(--color-gs300)',
    GS400: 'var(--color-gs400)',
    GS500: 'var(--color-gs500)',
    GS550: 'var(--color-gs550)',
    GS600: 'var(--color-gs600)',
    GS700: 'var(--color-gs700)',
    GS800: 'var(--color-gs800)',
    GS900: 'var(--color-gs900)',
    GS1000: 'var(--color-gs1000)',
    // Blue
    B100: 'var(--color-b100)',
    B200: 'var(--color-b200)',
    B300: 'var(--color-b300)',
    B400: 'var(--color-b400)',
    B500: 'var(--color-b500)',
    B600: 'var(--color-b600)',
    B700: 'var(--color-b700)',
    // Green
    G100: 'var(--color-g100)',
    G200: 'var(--color-g200)',
    G300: 'var(--color-g300)',
    G350: 'var(--color-g350)',
    G400: 'var(--color-g400)',
    G500: 'var(--color-g500)',
    // Yellow
    Y100: 'var(--color-y100)',
    Y200: 'var(--color-y200)',
    Y300: 'var(--color-y300)',
    Y400: 'var(--color-y400)',
    Y500: 'var(--color-y500)',
    // Red
    R100: 'var(--color-r100)',
    R200: 'var(--color-r200)',
    R300: 'var(--color-r300)',
    R400: 'var(--color-r400)',
    R500: 'var(--color-r500)',
};
//# sourceMappingURL=colors.js.map